import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";
import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import HeroPresenter from "presenters/HeroPresenter";
import CategoryCollectionPresenter from "presenters/CategoryCollectionPresenter";
import CategoryHeroPresenter from "presenters/CategoryHeroPresenter";
import SeoPresenter from "presenters/SeoPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    query: PropTypes.string,
    title: PropTypes.string,
    subheader: PropTypes.shape({}),
    pageModules: PropTypes.arrayOf(
      PropTypes.oneOfType([
        AlgoliaCardsPresenter.shape(),
        HeroPresenter.shape(),
        CategoryCollectionPresenter.shape(),
        CategoryHeroPresenter.shape(),
      ]),
    ),
    footer: PropTypes.shape(),
    seo: SeoPresenter.shape(),
  },
  {
    seoTitle(page) {
      if (!page) return "";

      return this.seo(page)?.title || this.title(page) || "";
    },
    seoDescription(page) {
      if (!page) return "";

      return this.seo(page)?.description || "";
    },
    seoOgTitle(page) {
      if (!page) return "";

      return SeoPresenter.ogTitle(this.seo(page)) || this.seoTitle(page);
    },
    seoOgDescription(page) {
      if (!page) return "";

      return SeoPresenter.ogDescription(this.seo(page)) || this.seoDescription(page);
    },
    seoIndexable(page) {
      if (!page) return false;

      return this.seo(page)?.isIndexable;
    },
    context(page) {
      if (!page) return "";

      switch (this.id(page)) {
        case "invites":
          return "invites";
        case "starring-you-ai":
          return "syai";
        default:
          return "category";
      }
    },
  },
);
